<template>
    <div>
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
      <div class="card">
          <div class="card-header">
              <h5>Buku Besar</h5>
          </div>
          <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group row">
                    <label for="account_code" class="col-sm-3 col-form-label text-left">Company</label>
                      <div class="col-sm-9">
                        <select v-model="company_no" class="form-control">
                          <option value="">-- All --</option>
                          <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                        </select>
                      </div>
                  </div>
                  <div class="form-group row">
                      <label for="account_code" class="col-sm-3 col-form-label text-left">Account</label>
                      <div class="col-sm-9">
                          <!-- <input type="text" class="form-control" v-model="account_code"/> -->
                        <v-select :options="getAccountSelect" :reduce="account => account.meta.code" label="account" v-model="account_code"/>
                      </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group row">
                    <label for="month" class="col-sm-3 col-form-label text-left">Date</label>
                    <div class="col-sm-9">
                      <date-picker v-model="startDate" type="date" range placeholder="Select date range"></date-picker>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="month" class="col-sm-3 col-form-label text-left">Contact</label>
                    <div class="col-sm-9">
                      <v-select :options="contactSelect" :reduce="contact => contact.meta.code" label="contact" v-model="contact" class="vsc-custom"/>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="year" class="col-sm-3 col-form-label text-left">&nbsp;</label>
                    <div class="col-sm-9">
                      <button type="button" class="btn btn-soft-primary" @click="refreshList">Search</button>
                      <button class="btn btn-warning pull-right dropdown-toggle" type="button" id="print" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fa fa-print" aria-hidden="true"></i> Print</button>
                      <div class="dropdown-menu" aria-labelledby="print">
                        <a class="dropdown-item" href="javascript:void(0)" @click="print('pdf')">PDF</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="print('excel')">Excel</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr>
              <div class="row">
                  <div class="col-md-12">
                    <span>Rows: <b>{{ journal.length | currency }}</b></span>
                    <span class="float-right font-14">Saldo: <b>{{ saldoAwal | currency }}</b></span>
                    <table class="table table-item mb-0 table-sm table-striped table-hover">
                        <thead>
                          <th>Account</th>
                          <th>Date</th>
                          <th>Journal No</th>
                          <th>Ref</th>
                          <th>Description</th>
                          <th>Remark</th>
                          <th class="text-right">Debit</th>
                          <th class="text-right">Credit</th>
                          <th class="text-right">Saldo</th>
                        </thead>
                        <tbody>
                            <tr v-for="j in journal" :key="j.id">
                              <td>{{ j.account_code }}</td>
                              <td>{{ j.journal_date | dateFormat('DD/MM/YYYY') }}</td>
                              <td>
                                <span @click="editJournal(j.jid)" data-toggle="modal" data-target="#modalJournalData" data-backdrop="static" data-keyboard="false">
                                  <b style="cursor: pointer;">{{ j.journal_code }}</b>
                                </span>
                              </td>
                              <td><i>{{ j.ref_no }}</i></td>
                              <td>{{ j.journal_description }}</td>
                              <td>{{ j.remark }}</td>
                              <td class="text-right">{{ j.debit | currency }}</td>
                              <td class="text-right">{{ j.credit | currency }}</td>
                              <td class="text-right">{{ j.saldo }}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="text-right">{{ totalDebit | currency }}</td>
                            <td class="text-right">{{ totalCredit | currency }}</td>
                            <td class="text-right">{{ totalDebit - totalCredit | currency }}</td>
                          </tr>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="text-right">Saldo in range date (coa)</td>
                            <td class="text-right"><b>{{ saldoRange | currency }}</b></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="text-right">Saldo</td>
                            <td class="text-right"><h5><b>{{ saldoAkhir }}</b></h5></td>
                          </tr>
                        </tfoot>
                    </table>
                  </div>
              </div>
          </div>
          <div class="card-footer"></div>
      </div>
      <JournalModal />
    </div>
</template>
<script>
import Axios from 'axios'
import { financeUrl, getHeader, report2Url } from '../../config'
import { mapState } from 'vuex'
import JournalModal from '@/components/journal/JournalModal.vue'
import DatePicker from 'vue2-datepicker'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'BukuBesar',
  components: {
    JournalModal,
    DatePicker,
    Loading
  },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      company_no: null,
      startDate: [date1, date2],
      account_code: null,
      month: date.getMonth() + 1,
      year: date.getFullYear(),
      saldoAwal: '0',
      saldoRange: '0',
      saldoAkhir: '0',
      contact: null,
      journal: [{
        no: null,
        jid: null,
        id: null,
        journal_code: null,
        account_code: null,
        remark: null,
        debit: 0,
        credit: 0,
        saldo: null,
        branch_no: null,
        journal_date: null,
        account: {
          id: null,
          type_code: null,
          account_code: null,
          account_name: null,
          notes: null,
          account_balance: null,
          group_id: null,
          method: null
        }
      }],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      },
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      }
    }
  },
  mounted () {
    this.$store.dispatch('getAccountList')
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getJournalContacts')
    // const local = window.localStorage.getItem('authUser')
    // this.company_no = null
  },
  computed: {
    ...mapState({
      accountList: state => state.accounts.accountList,
      companyList: state => state.companies.companyList,
      authUser: state => state.users.authUser,
      contactList: state => state.journals.journalContacts
    }),
    contactSelect: function () {
      var loop = []
      for (let i = 0; i < this.contactList.length; i++) {
        var obj = {
          contact: this.contactList[i].contact_no + ' - ' + this.contactList[i].contact_name,
          meta: {
            code: this.contactList[i].contact_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    totalCredit () {
      var sum = 0
      var array = this.journal
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].credit)
      }
      return sum
    },
    totalDebit () {
      var sum = 0
      var array = this.journal
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].debit)
      }
      return sum
    },
    companyData () {
      var company = null
      if (this.company_no === null) {
        company = this.authUser.company_no
      }
      return company
    },
    getAccountSelect: function () {
      var array = this.accountList.filter(d => d.company_no === this.company_no)
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var obj = {
          account: [array[i].account_code] + ' ' + array[i].account_name,
          meta: {
            code: array[i].account_code
          }
        }
        loop.push(obj)
      }
      return loop
    }
  },
  methods: {
    editJournal: function (id) {
      this.$store.dispatch('getJournal', id)
    },
    refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var data = {
        account: this.account_code,
        begin: begin,
        end: end,
        contact: this.contact,
        company_no: this.company_no
      }
      console.log(data)
      var url = financeUrl + '/buku-besar'
      console.log(url)
      console.log(data)
      Axios.post(url, data, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
          this.journal = response.data.data
          this.saldoAwal = response.data.saldoAwal
          this.saldoRange = response.data.saldoRange
          this.saldoAkhir = response.data.saldoAkhir
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$Progress.fail()
          this.loader.isLoading = false
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async print (type) {
      this.$Progress.start()
      this.loader.isLoading = true
      var data = {
        format: type,
        data: this.journal,
        saldoAwal: this.saldoAwal,
        totalDebit: this.totalDebit,
        totalCredit: this.totalCredit,
        saldoRange: this.saldoRange,
        saldoAkhir: this.saldoAkhir
      }
      if (data.length === 0) {
        this.$swal('Error', 'Data masih kosong', 'error')
        return false
      }
      console.log(data)
      await Axios.post(report2Url + '/buku-besar', data, { responseType: 'blob' })
        .then(response => {
          const objectUrl = URL.createObjectURL(response.data)
          console.log('Showing PDF...')
          window.open(objectUrl, '_blank')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
        })
    }
  }
}
</script>
